import { render, staticRenderFns } from "./ai_text_content.vue?vue&type=template&id=37f0c3e6&scoped=true"
import script from "./ai_text_content.vue?vue&type=script&lang=js"
export * from "./ai_text_content.vue?vue&type=script&lang=js"
import style0 from "./ai_text_content.vue?vue&type=style&index=0&id=37f0c3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0c3e6",
  null
  
)

export default component.exports